import { Stack, Typography, Chip } from "@mui/material";

export default function PrimeiraEtapa({ data }) {
  return (
    <Stack>
      <Typography className="item-text label color-blue-dark">
        Anamnese
      </Typography>

      <Typography className="item-text color-gray">
        {data?.anamnese ?? ""}
      </Typography>
      <Typography className="item-text label color-blue-dark" mt="15px">
        Sinais e sintomas
      </Typography>
      <Stack className="container-chip">
        {data?.sinaisSintomas.map(
          (value, index) =>
            value !== "" && <Chip className="chip" label={value} key={index} />
        )}
        {data?.sinaisSintomasOutro && (
          <Chip className="chip" label={data?.sinaisSintomasOutro ?? ""} />
        )}
      </Stack>
    </Stack>
  );
}
